import { PLAYER_PUBLIC_SITE_ID } from '../boot/siteId.js';

export function formatBdt(value, lang = 'en') {
  const num = Number(value);
  if (!Number.isFinite(num)) return '৳ 0';
  const loc = lang === 'bn' ? 'bn-BD' : 'en-US';
  return `৳ ${num.toLocaleString(loc)}`;
}

export function moneyClassName(value) {
  const num = Number(value);
  return Number.isFinite(num) && num < 0 ? 'money-negative' : '';
}

export function formatTurnoverDate(value, lang = 'en') {
  if (!value) return '—';
  try {
    const dt = new Date(value);
    if (Number.isNaN(dt.getTime())) return '—';
    return dt.toLocaleString(lang === 'bn' ? 'bn-BD' : 'en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
}

export function displayName(row) {
  return String(row?.name || row?.promotionTitle || row?.sourceLabel || 'Turnover');
}

/** Visual bound only. Does not recompute progress from completed/required. */
export function visualProgressPercent(progressPercent) {
  const pct = Number(progressPercent);
  if (!Number.isFinite(pct)) return 0;
  if (pct < 0) return 0;
  if (pct > 100) return 100;
  return pct;
}

export const API_SITE = PLAYER_PUBLIC_SITE_ID;
export const SESSION_KEY = 'ninet6_player_session';
export const DEFAULT_LIMIT = 20;

export function apiBase() {
  return `/api/site/${encodeURIComponent(API_SITE)}/v1`;
}

export function accessToken() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed?.accessToken || '';
  } catch {
    return '';
  }
}

export async function fetchPlayerTurnovers({ status, page = 1, limit = DEFAULT_LIMIT }) {
  const params = new URLSearchParams({
    status: String(status || ''),
    page: String(page),
    limit: String(limit),
  });
  const token = accessToken();
  const res = await fetch(`${apiBase()}/turnovers?${params}`, {
    headers: {
      Accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    cache: 'no-store',
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.message || json.error || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json;
}
